module.exports = __webpack_public_path__ + "img/home_footer_phone.82a836a2.png";